import React, { memo } from 'react';
import { Chip, type ChipProps } from '@mui/material';

type BadgeColor = ChipProps['color'];

const SEVERITY_COLORS: Record<string, BadgeColor> = {
  '1': 'error',
  '2': 'error',
  '3': 'warning',
  '4': 'info',
  critical: 'error',
  high: 'error',
  medium: 'warning',
  low: 'info',
};

export interface SeverityBadgeProps {
  severity: string;
  size?: 'small' | 'medium';
}

const SeverityBadge: React.FC<SeverityBadgeProps> = memo(({ severity, size = 'small' }) => {
  const color = SEVERITY_COLORS[severity] ?? 'default';
  const label = /^\d+$/.test(severity) ? `Sev ${severity}` : severity;

  return (
    <Chip
      label={label}
      color={color}
      size={size}
      sx={{
        fontSize: '0.7rem',
        height: size === 'small' ? 22 : undefined,
        fontWeight: 500,
        textTransform: 'capitalize',
      }}
    />
  );
});

SeverityBadge.displayName = 'SeverityBadge';

export default SeverityBadge;
